(function () {
  const root = document.getElementById('SitePopup');
  if (!root) return;

  const storageKey = root.dataset.storageKey || 'sitePopupDismissed';
  const showDelay = parseInt(root.dataset.showDelay || '0', 10) || 0;
  const transitionDuration = parseInt(root.dataset.transitionDuration || '350', 10) || 350;

  const hasDismissed = (() => {
    try {
      return window.localStorage.getItem(storageKey) === 'true';
    } catch (error) {
      return false;
    }
  })();

  if (hasDismissed) return;

  const overlay = root.querySelector('[data-site-popup-overlay]');
  const closeButton = root.querySelector('[data-site-popup-close]');
  const form = root.querySelector('[data-site-popup-form]');
  const focusTarget = root.querySelector('[data-site-popup-input]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let hideTimer = null;

  const persistDismissal = () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      /* no-op */
    }
  };

  const cleanUp = () => {
    document.removeEventListener('keydown', handleKeydown);
  };

  const closePopup = (persist = true) => {
    if (!root.classList.contains('is-visible')) return;

    root.classList.remove('is-visible');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('site-popup-open');

    if (hideTimer) {
      window.clearTimeout(hideTimer);
    }

    hideTimer = window.setTimeout(() => {
      root.hidden = true;
    }, transitionDuration);

    if (persist) {
      persistDismissal();
    }

    cleanUp();
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup(true);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = root.querySelectorAll(focusableSelector);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const openPopup = () => {
    if (root.classList.contains('is-visible')) return;

    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('site-popup-open');

    requestAnimationFrame(() => {
      root.classList.add('is-visible');
      const initialFocusTarget = focusTarget || root.querySelector(focusableSelector);
      if (initialFocusTarget && typeof initialFocusTarget.focus === 'function') {
        initialFocusTarget.focus();
      }
    });

    document.addEventListener('keydown', handleKeydown);
  };

  const scheduleOpen = () => {
    window.setTimeout(openPopup, showDelay);
  };

  if (overlay) {
    overlay.addEventListener('click', () => closePopup(true));
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => closePopup(true));
  }

  if (form) {
    form.addEventListener('submit', persistDismissal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleOpen, { once: true });
  } else {
    scheduleOpen();
  }
})();
